import { type FC, useId } from 'react';
import { MiniGridRow, StubCell } from '@direct-frontend/components';

type AddonRowStubProps = {};

export const AddonRowStub: FC<AddonRowStubProps> = ({}) => {
    const id = useId();

    return (
        <MiniGridRow id={id}>
            <StubCell withCaption />
        </MiniGridRow>
    );
};
